// extracted by mini-css-extract-plugin
module.exports = {"ThumbsButton":"ThumbsButton_ThumbsButton__LWF94","MainButton":"ThumbsButton_MainButton__2DFl_"};